<template>
	<div class="product-center">
		<h1>{{ $t('home.产品中心') }}</h1>
		<p>{{ $t('home.带您发现唯泰斯优质好物') }}</p>
		<button class="learn-more-btn learn-more-btn-0" @click="gotoProducts()">{{ $t('home.了解更多') }}</button>

		<div class="product-grid">
			<div class="product-card main-product" style="grid-column: span 2" :style="{ backgroundImage: `url(${mainProduct.image})` }">
				<div></div>
				<div class="product-info">
					<div style="flex: 1">
						<h2>{{ mainProduct.title }}</h2>
						<p>{{ mainProduct.subtitle }}</p>
					</div>
					<button class="learn-more-btn" @click="gotoProducts()">{{ $t('home.了解更多') }}</button>
				</div>
			</div>

			<div v-for="(product, index) in products" :key="index" class="product-card">
				<img :src="product.image" alt="Product" />
				<h3>{{ product.title }}</h3>
				<p>{{ product.subtitle }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { homeProductApi, baseImgUrl } from '../netTool/api';

export default {
	data() {
		return {
			mainProduct: {
				image: '',
				title: '',
				subtitle: ''
			},
			products: []
		};
	},
	mounted() {
		this.loadHomeProducts();
	},
	methods: {
		async loadHomeProducts() {
			try {
				const response = await homeProductApi.getAllHomeProducts();
				if (response.success) {
					const featuredProduct = response.data.find((item) => item.is_featured === '1');
					const normalProducts = response.data.filter((item) => item.is_featured === '0');

					if (featuredProduct) {
						this.mainProduct = {
							image: featuredProduct.featured_image_url
								? baseImgUrl + featuredProduct.featured_image_url
								: featuredProduct.image_url
								? baseImgUrl + featuredProduct.image_url
								: require('@/assets/logo.png'),
							title: featuredProduct.product_name,
							subtitle: featuredProduct.tags
						};
					}

					this.products = normalProducts.map((product) => ({
						image: product.image_url ? baseImgUrl + product.image_url : require('@/assets/logo.png'),
						title: product.product_name,
						subtitle: product.tags
					}));
				}
			} catch (error) {
				console.error('加载首页产品失败:', error);
			}
		},
		gotoProducts() {
			this.$router.push('/products');
		}
	}
};
</script>

<style scoped>
.product-center {
	text-align: center;
	padding: 40px 18px;
}

h1 {
	font-size: 2.5rem;
	margin-bottom: 30px;
}

p {
	color: #666;
	margin-bottom: 35px;
	font-size: 19px;
}

.learn-more-btn {
	padding: 10px 20px;
	border: 1px solid #ccc;
	border-radius: 20px;
	background-color: white;
	cursor: pointer;
}

.learn-more-btn-0 {
	margin-bottom: 35px;
}

/* 网格布局 */
.product-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr); /* 3列布局 */
	gap: 20px; /* 卡片间距 */
	max-width: 1200px;
	margin: 0 auto;
}

/* 主产品样式 */
.main-product {
	min-height: 240px;
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: center;
	background-size: cover; /* 覆盖整个容器 */
	background-repeat: no-repeat;
	background-position: center;
}

.product-info {
	position: absolute;
	bottom: 10px;
	display: flex;
	width: 85%;
	text-align: left;
	align-items: center;
	justify-content: center;
}

/* 普通产品卡片样式 */
.product-card {
	background-color: #ebebeb;
	border: 1px solid #eee;
	border-radius: 8px;
	padding: 15px 25px;
	text-align: center;
	transition: transform 0.2s;
	box-sizing: border-box;
}

.product-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.product-card img {
	max-width: 100%;
	height: auto;
	margin-bottom: 16px;
}

.product-card h3 {
	text-align: left;
}
.product-card p {
	text-align: left;
}

@media (max-width: 768px) {
	.main-product {
		grid-column: 1 / -1;
	}
	.product-grid {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
